"use client";
import { useEffect, useRef } from "react";

import { useSearchParams } from "next/navigation";

import { Params } from "~/constants/request";

export const useGetPageNumberRef = (): React.RefObject<number> => {
  const searchParams = useSearchParams();
  const pageNumber = useRef<number>(Number(searchParams.get("page") || 1));

  useEffect(() => {
    pageNumber.current = Number(
      location?.search?.split(`${Params.PAGE}=`)?.[1] || 1,
    );
  });
  return pageNumber;
};
